import React from "react";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import { Tabs } from "antd";
import { InfoCircleOutlined, HomeOutlined } from "@ant-design/icons";

const AppHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const activeKey = location.pathname === "/info" ? "info" : "main";

  const handleTabChange = (key) => {
    if (key === "info") {
      navigate("/info");
    } else if (key === "main") {
      navigate("/");
    }
  };

  return (
    <HeaderContainer>
      <Title>SLAYER SCAPE</Title>
      <StyledTabs
        activeKey={activeKey}
        onChange={handleTabChange}
        items={[
          {
            key: "main",
            label: (
              <>
                <HomeOutlined />
                <TabText>Main</TabText>
              </>
            ),
          },
          {
            key: "info",
            label: (
              <>
                <InfoCircleOutlined />
                <TabText>Info</TabText>
              </>
            ),
          },
        ]}
      />
    </HeaderContainer>
  );
};

export default AppHeader;

const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 5px 10px;
  background-color: #3b3b3b;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Title = styled.h1`
  font-size: 1.8rem;
  color: #ffff00;
  font-family: "Chakra Petch", sans-serif;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    background-color: #4a4a4a;
    border-radius: 8px;
    padding: 3px 10px;
    margin-bottom: 0px;
  }

  .ant-tabs-tab {
    font-size: 16px;
    color: #ffffff;
  }

  .ant-tabs-tab:hover {
    color: #ffff00;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #ffff00;
  }

  .ant-tabs-ink-bar {
    background-color: #ffff00;
  }

  @media (max-width: 768px) {
    width: 100%;
    margin-top: 5px;
  }
`;

const TabText = styled.span`
  margin-left: -4px;
  font-family: "Chakra Petch", sans-serif;
`;
